(() => {
  'use strict';

  const selector = 'img[data-fxl-deferred-src]';
  const registeredCards = new WeakSet();
  const registeredImages = new WeakSet();
  const trackObservers = new WeakMap();

  const hydrate = image => {
    if (!(image instanceof HTMLImageElement) || !image.dataset.fxlDeferredSrc) return;
    if (image.dataset.fxlDeferredSizes) image.sizes = image.dataset.fxlDeferredSizes;
    if (image.dataset.fxlDeferredSrcset) image.srcset = image.dataset.fxlDeferredSrcset;
    image.src = image.dataset.fxlDeferredSrc;
    delete image.dataset.fxlDeferredSrc;
    delete image.dataset.fxlDeferredSrcset;
    delete image.dataset.fxlDeferredSizes;
    image.dataset.fxlDeferredReady = '';
  };

  const hydrateWithin = root => root.querySelectorAll(selector).forEach(hydrate);

  const cardObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          hydrateWithin(entry.target);
          cardObserver.unobserve(entry.target);
        });
      }, { rootMargin: '500px 0px', threshold: 0.01 })
    : null;

  const observeThumbnailTrack = track => {
    if (trackObservers.has(track)) return;
    if (!('IntersectionObserver' in window)) {
      hydrateWithin(track);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        hydrate(entry.target);
        observer.unobserve(entry.target);
      });
    }, { root: track, rootMargin: '0px 180px', threshold: 0.01 });
    trackObservers.set(track, observer);
    track.querySelectorAll(selector).forEach(image => {
      if (registeredImages.has(image)) return;
      registeredImages.add(image);
      observer.observe(image);
    });
  };

  const scan = (root = document) => {
    root.querySelectorAll('[data-fxl-catalog-card]').forEach(card => {
      if (registeredCards.has(card) || !card.querySelector(selector)) return;
      registeredCards.add(card);
      if (cardObserver) cardObserver.observe(card);
      else hydrateWithin(card);
    });
    root.querySelectorAll('.mry-pdp__thumbs').forEach(observeThumbnailTrack);
  };

  document.addEventListener('pointerover', event => {
    const card = event.target.closest?.('[data-fxl-catalog-card]');
    if (card) hydrateWithin(card);
    const thumb = event.target.closest?.('.mry-pdp__thumb');
    if (thumb) hydrateWithin(thumb);
  }, { passive: true });
  document.addEventListener('focusin', event => {
    const group = event.target.closest?.('[data-fxl-catalog-card], .mry-pdp__thumb');
    if (group) hydrateWithin(group);
  });
  document.addEventListener('shopify:section:load', event => scan(event.target));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  else scan();

  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType !== Node.ELEMENT_NODE) return;
      if (node.matches?.('[data-fxl-catalog-card], .mry-pdp__thumbs')) scan(node.parentElement || node);
      else if (node.querySelector?.('[data-fxl-catalog-card], .mry-pdp__thumbs')) scan(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
